import component from './FiltersConstructor.vue'
export default component
